<form [formGroup]="form">
  <div class="row">
    <div class="form-group col-md-4">
      <label for="memberslist">Välj medlem</label>
      <p-select id="member" [options]="memberslist" [filter]="true" [showClear]="true" [style]="{ width: '100%' }" (onChange)="setSingleMember($event)"></p-select>
    </div>
    <div class="form-group col-md-2">
      <label for="startDate">Från månad</label>
      <input type="text" class="form-control form-control-sm" formControlName="startDate" id="startDate" style="max-width:80px;" format="yyyy-MM" mask="0000-00" required>
    </div>
    <div class="form-group col-md-2">
      <label for="endDate">Till månad</label>
      <input type="text" class="form-control form-control-sm" formControlName="endDate" id="endDate" style="max-width:80px;" format="yyyy-MM" mask="0000-00" required>
    </div>
    <div class="form-group col-md-2">
      <label for="percent">%</label>
      <input type="text" class="form-control form-control-sm" formControlName="payPercentage" id="payPercentage" style="max-width:60px;" required (change)="checkPercent($event)">
    </div>
    <div class="form-group col-md-2">
      <label>&nbsp;</label>
      <button class="btn border pull-right" style="margin-right:16px;" (click)="add()" [disabled]="!form.valid">Lägg till</button>
    </div>
  </div>
</form>
<p-table #dt [columns]="cols" [value]="memberfees" [paginator]="false" dataKey="memberId" [autoLayout]="true">
  <ng-template pTemplate="caption">
    <div style="text-align: left;">Nedsättning<span style="margin-left:50px;">Antal poster:
        {{memberfees?.length}}
        <span style="margin-left:40px;">Normal årsavgift: {{annualamount}} kr</span>
        <span style="text-align:right;"><button class="btn border pull-right" (click)="exportToCSV()">Excel</button></span></span></div>
    <br>
    <div style="text-align: right">
      <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
      <input type="text" pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
        </p-sortIcon>
      </th>
      <th style="width:100px;">Action</th>
    </tr>
    <tr>
      <th *ngFor="let col of columns" [ngSwitch]="col.field">
        <input *ngSwitchCase="'memberId'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        <input *ngSwitchCase="'givenName'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        <input *ngSwitchCase="'shortName'" pInputText type="text" [value]="dt.filters['shortName'] ? dt.filters['shortName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        <input *ngSwitchCase="'familyName'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        <input *ngSwitchCase="'startDate'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        <input *ngSwitchCase="'endDate'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-expanded="expanded" let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        <span *ngIf="col.field === 'shortName'"><a [routerLink]="['/institutions']" [queryParams]="{id: rowData['primaryInstitution']?.id}" queryParamsHandling="merge" title="{{rowData[col.field]}} {{rowData['primaryInstitution'].name}}">{{rowData[col.field]}}</a>
        </span>
        <a *ngIf="col.field === 'memberId'" [routerLink]="['/memberform/id/', rowData[col.field]]">{{rowData[col.field]}}</a>
        <span *ngIf="col.field !== 'memberId' && col.field !== 'annualAmount' && col.field !== 'shortName'">{{rowData[col.field]}}</span>
        <span *ngIf="col.field === 'annualAmount' && annualamount > 0"> {{(rowData['feeAfterDiscount'])}}</span>
      </td>
      <td><span style="display: inline-block;"><a href="#" (click)="editRow(rowData); $event.preventDefault()">Ändra</a><i *ngIf="edit_memfee" class="fa fa-trash ms-4" style="font-size:12px;" title="Radera aktuell rad" (click)="deleteRow(rowData)"></i></span></td>
    </tr>
  </ng-template>
</p-table>

<p-dialog header="Ändra nedsättning för {{rowdata?.memberId}} {{rowdata?.givenName}} {{rowdata?.familyName}}" [(visible)]="editview" [modal]="true" [style]="{'width': '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true">
  <app-edit-nedsattning [rowdata]=rowdata (doSave)="save($event)" (doClose)="close($event)"></app-edit-nedsattning>
</p-dialog>
